import React, { useState } from "react";

const PART_COLORS = [
  { header: "#0ea5e9", light: "#f0f9ff", border: "#bae6fd", check: "#0ea5e9" },
  { header: "#7c3aed", light: "#f5f3ff", border: "#c4b5fd", check: "#7c3aed" },
  { header: "#059669", light: "#f0fdf4", border: "#6ee7b7", check: "#059669" },
  { header: "#d97706", light: "#fffbeb", border: "#fcd34d", check: "#d97706" },
  { header: "#db2777", light: "#fdf2f8", border: "#f9a8d4", check: "#db2777" },
  { header: "#0891b2", light: "#ecfeff", border: "#67e8f9", check: "#0891b2" },
];

export default function Checklist({ items, lessonId }) {
  // Support both old flat array and new parts format
  const parts = Array.isArray(items)
    ? [{ label: "Section checklist", items }]
    : items.parts || [{ label: "Section checklist", items: [] }];

  const totalItems = parts.reduce((sum, p) => sum + p.items.length, 0);
  const key = `sl_checklist_${lessonId}`;

  const [checked, setChecked] = useState(() => {
    try { return JSON.parse(localStorage.getItem(key) || "{}"); }
    catch { return {}; }
  });

  const toggle = (globalIdx) => {
    const next = { ...checked, [globalIdx]: !checked[globalIdx] };
    setChecked(next);
    localStorage.setItem(key, JSON.stringify(next));
  };

  const doneCount = Object.values(checked).filter(Boolean).length;

  let globalIdx = 0;

  return (
    <div style={{ marginTop: 24, border: "1px solid #e2e8f0", borderRadius: 8, overflow: "hidden" }}>
      <div style={{
        background: "#1e293b", padding: "12px 18px",
        display: "flex", justifyContent: "space-between", alignItems: "center",
        borderBottom: "1px solid #334155",
      }}>
        <h4 style={{ fontWeight: 800, color: "#fff", fontSize: 15, margin: 0 }}>
          Section checklist
        </h4>
        <span style={{
          fontSize: 12, fontWeight: 700,
          color: doneCount === totalItems ? "#4ade80" : "#94a3b8",
        }}>
          {doneCount}/{totalItems} done
        </span>
      </div>

      {parts.map((part, pi) => {
        const color = PART_COLORS[pi % PART_COLORS.length];
        const partEl = (
          <div key={pi}>
            <div style={{
              background: color.header, padding: "8px 18px",
              fontSize: 11, fontWeight: 700, color: "#fff",
              letterSpacing: 0.8, textTransform: "uppercase",
            }}>
              {part.label}
            </div>
            <div style={{ padding: "12px 18px", background: color.light }}>
              {part.items.map((item, i) => {
                const idx = globalIdx;
                globalIdx++;
                return (
                  <label key={i} style={{
                    display: "flex", gap: 10, alignItems: "flex-start",
                    marginBottom: 10, cursor: "pointer",
                  }}>
                    <input
                      type="checkbox"
                      checked={!!checked[idx]}
                      onChange={() => toggle(idx)}
                      style={{ marginTop: 3, accentColor: color.check, flexShrink: 0 }}
                    />
                    <span style={{
                      fontSize: 13,
                      color: checked[idx] ? "#94a3b8" : "#374151",
                      textDecoration: checked[idx] ? "line-through" : "none",
                      lineHeight: 1.7,
                    }}>
                      {item}
                    </span>
                  </label>
                );
              })}
            </div>
          </div>
        );
        return partEl;
      })}

      {doneCount === totalItems && totalItems > 0 && (
        <div style={{
          background: "#f0fdf4", borderTop: "1px solid #bbf7d0",
          padding: "12px 18px", fontSize: 13, color: "#16a34a", fontWeight: 700,
        }}>
          ✓ Section checklist complete — you are ready to move forward.
        </div>
      )}
    </div>
  );
}